import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

// base: "/admin/support-chat" (admin panel) or "/support-assign" (granted users)
export function ReopenChatButton({ chatId, base, L, onDone }) {
  const reopen = async () => {
    if (!window.confirm(L("إعادة فتح هذه المحادثة؟", "Reopen this conversation?"))) return;
    try { await api.post(`${base}/chats/${chatId}/reopen`); toast.success(L("تمت إعادة فتح المحادثة", "Conversation reopened")); onDone(); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <button type="button" onClick={reopen} className="mt-3 w-full h-11 rounded-xl bg-[#0F4D32] hover:bg-[#0b3d27] text-white font-bold flex items-center justify-center gap-2 transition-colors" data-testid={`support-reopen-${chatId}`}>
      <RotateCcw className="w-4 h-4" />{L("إعادة فتح المحادثة", "Reopen conversation")}
    </button>
  );
}
